import React from "react"; // Make sure to import your image
// import { IoLogoReact } from 'react-icons/io';
import {
  FaCheckCircle,
  FaReact,
  FaNodeJs,
  FaAndroid,
  FaDatabase,
  FaPaintBrush,
  FaNetworkWired,
} from "react-icons/fa";

import appimg from "../assets/img/app.jpg";

const data = [
  {
    type: "ECommerce Web App",
    functionalities:
      "Product listing, shopping cart, payment gateways, user accounts",
    example: "Amazon, Shopify",
    costEstimate: "$50,000 to $300,000+",
  },
  {
    type: "Social Media Platform",
    functionalities: "User profiles, news feed, messaging, content sharing",
    example: "Facebook, Instagram",
    costEstimate: "$60,000 to $250,000+",
  },
  {
    type: "Content Management System (CMS)",
    functionalities: "Content creation, publishing, user management",
    example: "WordPress, Joomla",
    costEstimate: "$30,000 to $100,000+",
  },
  {
    type: "Marketplace",
    functionalities: "Search, listing, user profiles, payment system",
    example: "Airbnb, Etsy",
    costEstimate: "$80,000 to $400,000+",
  },
  {
    type: "Static Web App",
    functionalities: "Fixed content, simple structure",
    example: "Portfolio sites",
    costEstimate: "$20,000 to $60,000",
  },
  {
    type: "Enterprise Web App",
    functionalities: "CRM, data management, analytics, collaboration tools",
    example: "Salesforce, SAP",
    costEstimate: "$100,000 to $500,000+",
  },
  {
    type: "Healthcare Web App",
    functionalities:
      "Patient record keeping, appointment scheduling, telemedicine",
    example: "WebMD, Doctor On Demand",
    costEstimate: "$50,000 to $300,000+",
  },
  {
    type: "eLearning Web App",
    functionalities: "Online courses, progress tracking, virtual classes",
    example: "Coursera, Udemy",
    costEstimate: "$30,000 to $200,000+",
  },
];

const AppDevelopmentPage = () => {
  return (
    <section className="py-16 px-10 bg-white">
      <div className="container mx-auto">
        <h1 className="text-4xl font-bold text-gray-800 text-center mb-12">
          App Development
        </h1>{" "}
        {/* Increased bottom margin for padding */}
        <div className="flex flex-col md:flex-row">
          {/* Left Column */}
          <div className="md:w-1/2 md:pr-4 mb-8">
            <h2 className="text-2xl font-semibold mb-4">
              About App Development
            </h2>
            <p className="text-gray-700 mb-4">
              Our web development services provide tailored solutions to meet
              your business needs. From creating responsive websites to
              developing complex web applications, we ensure high performance
              and scalability.
            </p>
            <h3 className="text-lg font-semibold mb-2">Services We Offer:</h3>
            <ul className="list-disc list-inside mb-4">
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                Custom Website Development
              </li>
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                E-commerce Solutions
              </li>
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                Content Management Systems (CMS)
              </li>
              <li className="flex items-center mb-2">
                <FaCheckCircle className="text-green-500 mr-2" />
                Website Maintenance & Support
              </li>
            </ul>
          </div>

          {/* Right Column */}
          <div className="md:w-1/2 md:pl-4 mb-8">
            <img
              src={appimg}
              alt="Web Development Services"
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>
        <h2 className="text-2xl font-semibold text-center my-8 underline">
          Our Pricing
        </h2>
        <div className="overflow-x-auto px-20 pt-5">
          <table className="min-w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200 text-gray-600">
                <th className="border border-gray-300 px-4 py-2">Type</th>
                <th className="border border-gray-300 px-4 py-2">
                  Functionalities
                </th>
                <th className="border border-gray-300 px-4 py-2">Example</th>
                
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-white">
                  <td className="border border-gray-300 px-4 py-2">
                    {item.type}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {item.functionalities}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {item.example}
                  </td>
              
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <h2 className="text-2xl font-semibold text-center my-8">
          Technology We Use
        </h2>
        <p className="text-gray-700 text-center mb-4">
          We leverage cutting-edge technologies to deliver high-quality web
          solutions.
        </p>
        <div className="grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 gap-6 my-8 mx-auto max-w-4xl">
          <div className="bg-white shadow-lg p-6 flex flex-col items-center rounded-lg text-center">
            <FaReact className="text-blue-500 text-5xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">React Native</h3>
            <p className="text-gray-600">
              A JavaScript library for building user interfaces.
            </p>
          </div>
          <div className="bg-white shadow-lg p-6 flex flex-col items-center rounded-lg text-center">
            <FaNodeJs className="text-green-500 text-5xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Node.js</h3>
            <p className="text-gray-600">
              JavaScript runtime for server-side development.
            </p>
          </div>
         
          <div className="bg-white shadow-lg p-6 flex flex-col items-center rounded-lg text-center">
            <FaAndroid className="text-green-600 text-5xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Android Studio</h3>
            <p className="text-gray-600">
              Official IDE for Android development.
            </p>
          </div>
          <div className="bg-white shadow-lg p-6 flex flex-col items-center rounded-lg text-center">
            <FaDatabase className="text-green-600 text-5xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">MongoDB</h3>
            <p className="text-gray-600">
              A NoSQL database for modern applications.
            </p>
          </div>
          <div className="bg-white shadow-lg p-6 flex flex-col items-center rounded-lg text-center">
            <FaPaintBrush className="text-indigo-500 text-5xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Tailwind CSS</h3>
            <p className="text-gray-600">
              A utility-first CSS framework for rapid UI development.
            </p>
          </div>
          <div className="bg-white shadow-lg p-6 flex flex-col items-center rounded-lg text-center">
            <FaNetworkWired className="text-blue-500 text-5xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">RESTful APIs</h3>
            <p className="text-gray-600">
              Architectural style for scalable web services.
            </p>
          </div>
        </div>
        <h2 className="text-2xl font-semibold text-center my-8">
          Understand the Development Process
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-gray-700 text-center mb-8 max-w-5xl mx-auto">
          <div className="bg-white shadow-lg p-6 rounded-lg transform transition-all duration-500 hover:scale-105 hover:shadow-2xl animate-fade-in-up">
            <i className="fas fa-pencil-ruler text-blue-500 text-5xl mb-4"></i>
            <h3 className="text-lg font-semibold mb-2">
              01. Design and Planning
            </h3>
            <p>
              Understand your vision, create a detailed plan, and develop
              wireframes.
            </p>
          </div>

          <div className="bg-white shadow-lg p-6 rounded-lg transform transition-all duration-500 hover:scale-105 hover:shadow-2xl animate-fade-in-up">
            <i className="fas fa-laptop-code text-green-500 text-5xl mb-4"></i>
            <h3 className="text-lg font-semibold mb-2">
              02. Development and Testing
            </h3>
            <p>
              Build the app using the latest technologies and perform rigorous
              testing.
            </p>
          </div>

          <div className="bg-white shadow-lg p-6 rounded-lg transform transition-all duration-500 hover:scale-105 hover:shadow-2xl animate-fade-in-up">
            <i className="fas fa-rocket text-red-500 text-5xl mb-4"></i>
            <h3 className="text-lg font-semibold mb-2">03. Launch & Support</h3>
            <p>
              Deploy the app to stores and provide ongoing updates and
              maintenance.
            </p>
          </div>
        </div>
        
      
      </div>
    </section>
  );
};

export default AppDevelopmentPage;
